import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { AssetPrefix } from '../../models/AssetPrefix';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class PrefixProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.assetApi + '/api/v1/prefix';

  getPrefixes(): Observable<ApiResponse<AssetPrefix[]>> {
    return this.httpClient.get<ApiResponse<AssetPrefix[]>>(`${this.baseUrl}/all`);
  }

  upsertPrefix(category: AssetPrefix): Observable<ApiResponse<AssetPrefix>> {
    return this.httpClient.post<ApiResponse<AssetPrefix>>(`${this.baseUrl}`, category);
  }

  deletePrefix(id: string): Observable<AssetPrefix> {
    return this.httpClient.delete<AssetPrefix>(`${this.baseUrl}/${id}`);
  }
}
